import React, {useEffect, useState} from 'react';
import stl from './SelectTipRecipient.module.css';
import pageLogo from '../../assets/pageLogo.png'
import PersonCard from "../../molecules/PersonCard";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import { doc, getDoc, DocumentReference } from "firebase/firestore";
import {db} from "../../firebase";
import {Preloader} from "../../atoms/Preloader";
import {initAmplitude, logEvent} from "../../amplitude";
import getGuestId from "../../storage/getGuestId";

const SelectTipRecipient = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const guestId = getGuestId();
    const { teamId } = useParams();
    const [employees, setEmployees ] = useState(null);
    const [loading, setLoading ] = useState(false);
    useEffect(() => {
        logEvent("Page view", {
            Title: 'Employee selection',
            Path: location.pathname,
            URL: window.location.href,
            'Guest ID': guestId,
        });
    }, []);

    const handleEmployeeSelect = async (employee) => {
        console.log(employee.user, 'employees.user');
        logEvent("Employee selected", {
            'Employee ID': employee?.service_id,
            'Guest ID': guestId,
        });
        await localStorage.clear();
        navigate(`/service/${employee?.service_id}`, { state: { employee } });
    };
    async function fetchGroupAndEmployeesData() {
        setLoading(true)
        try {
            const groupDoc = doc(db, 'teams', teamId);
            const docSnapshot = await getDoc(groupDoc);

            if (docSnapshot.exists()) {
                const groupData = docSnapshot.data();
                console.log('Group data:', groupData);
                if (groupData.services && groupData.services.length > 0) {
                    const employeesData = await fetchEmployeesData(groupData.services);
                    console.log('Products data:', employeesData);
                    setEmployees(employeesData)
                    setLoading(false)
                } else {
                    console.log('No products found for this group.');
                }
            } else {
                console.log('No such document!');
            }
        } catch (error) {
            console.error('Error fetching group by ID: ', error);
        }
    }

    async function fetchEmployeesData(serviceIds) {
        const services = [];

        for (const serviceId of serviceIds) {
            try {
                // Используем прямую ссылку на документ по ID
                const docRef = doc(db, 'services', serviceId);
                const docSnapshot = await getDoc(docRef);

                if (docSnapshot.exists()) {
                    const productData = docSnapshot.data();
                    const { user, ...filteredProductData } = productData;
                    console.log(productData, 'productdata')
                    if (user && user instanceof DocumentReference) {
                        try {
                            console.log('User field found:', user);
                            const userSnapshot = await getDoc(user);

                            if (userSnapshot.exists()) {
                                filteredProductData.user = userSnapshot.data();
                            } else {
                                console.log('Документ пользователя не найден');
                                filteredProductData.user = null;
                            }
                        } catch (userError) {
                            console.error('Ошибка при получении данных пользователя: ', userError);
                            filteredProductData.user = null;
                        }
                    } else {
                        console.warn(`Поле user не является DocumentReference или отсутствует для продукта с ID ${docSnapshot.id}`);
                        filteredProductData.user = null; // Если user не ссылка на документ
                    }

                    services.push({
                        id: docSnapshot.id,
                        ...filteredProductData,
                    });
                } else {
                    console.log(`Продукт с ID: ${serviceId} не найден`);
                }
            } catch (error) {
                console.error(`Ошибка при получении продукта с ID ${serviceId}: `, error);
            }
        }

        return services;
    }



    useEffect(() => {
        fetchGroupAndEmployeesData();
    }, []);

    if (loading) return <Preloader/>
    return (
        <div className={stl.container}>
           <div className={stl.containerInner}>
               <div className={stl.pageLogoBox}>
                   <img src={pageLogo} alt='pageLogo' className={stl.pageLogo} />
               </div>
               <div className={stl.titleBox}>
                   <h2 className={stl.title}>Pick your favorite to thank with a tip!</h2>
               </div>
               <div className={stl.personsList}>
                   {employees?.map((employee) => (
                         <PersonCard key={employee?.id} person={employee} onPersonSelect={handleEmployeeSelect} />
                   ))}
               </div>
           </div>
        </div>
    );
};

export default SelectTipRecipient;
